import cls from 'classnames'
import { ChangeEvent } from 'preact/compat'
import { h, FunctionComponent } from 'preact'
import { useContext } from 'preact/hooks'
import FieldsContext from 'components/business/SurveyForm/Fields/fieldsContext'
import { ChoicesSize } from 'scripts/type'

import classes from './option.scss'

type OptionProps = {
  value: string
  type: 'checkbox' | 'radio'
  className?: string
  checked?: boolean
  choicesSize?: ChoicesSize
  rowChoiceCount?: number
  onChange?: (value: string, checked: boolean) => void
  disabled?: boolean
}

const Option: FunctionComponent<OptionProps> = (props) => {
  const { windowSizeSm } = useContext(FieldsContext)!
  const { checked = false, type, className = '', value, children, onChange, disabled, ...restProps } = props
  const isSmall = props.choicesSize === ChoicesSize.Small

  const classNames = cls(classes.optionLabel, classes[type], windowSizeSm && classes.sm, className, {
    [classes.checked]: checked,
    [classes.small]: isSmall,
  })

  const getOptionStyle = () => {
    if (props.rowChoiceCount) {
      return {
        width: `calc(${100 / props.rowChoiceCount}% - 8px)`, // 8 : option marginRight
      }
    }
    return undefined
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    // @ts-ignore
    const { checked, value } = event.target!
    if (!checked && type === 'radio') return
    onChange?.(value, checked)
  }

  return (
    <div
      className={cls(
        classes.option,
        !windowSizeSm && classes.optionWeb,
        checked && classes.checked,
        checked && 'pulse-for-big',
        { [classes.disabled]: disabled }
      )}
      style={getOptionStyle()}
    >
      <label className={classNames} disabled={disabled}>
        <span className={classes.optionWrapper}>
          <input
            disabled={disabled}
            type="checkbox"
            className={classes.optionInput}
            checked={checked}
            value={value}
            onChange={handleChange}
            {...restProps}
            data-testid="checkbox"
          />
        </span>
        {children && (
          <span
            className={cls(
              classes.optionText,
              props.rowChoiceCount && 'text-center',
              props.rowChoiceCount && props.rowChoiceCount !== 1 && 'truncate',
              checked && classes.checkedOptionText,
              isSmall && classes.small
            )}
          >
            {children}
          </span>
        )}
      </label>
    </div>
  )
}

export default Option
